import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import SideBar from "../components/my-account/sidebar";
const MyAccount = () => {
  return (
    <>
      <section className="section-padding my-account-section">
        <Container className="booking-container">
          <Row>
            <Col lg={3} className="d-lg-block d-none">
              <SideBar />
            </Col>
            <Col lg="9">
              <div className="account-card">
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default MyAccount;
